export enum SupplierStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}
